import React, { useEffect, useRef, useState } from 'react';
import { getDeviceHostname, getDeviceInfoDetailFields } from '../utils/deviceInfo';
import './DeviceInfoPopover.css';

const DETAIL_ROWS = [
  ['OS', 'os'],
  ['Hostname', 'hostname'],
  ['Machine', 'machine'],
  ['MAC', 'mac'],
  ['CPU', 'cpu'],
  ['Device ID', 'deviceId'],
];

const DeviceInfoCell = ({ deviceInfo }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const hostname = getDeviceHostname(deviceInfo);
  const details = getDeviceInfoDetailFields(deviceInfo);
  const hasDetails = details && DETAIL_ROWS.some(([, key]) => details[key]);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <div className="device-info-cell-wrap" ref={wrapRef}>
      <span className="device-info-hostname">{hostname}</span>
      {hasDetails && (
        <button
          type="button"
          className="device-info-view-btn"
          title="View full device info"
          onClick={() => setOpen((prev) => !prev)}
        >
          View
        </button>
      )}
      {open && hasDetails && (
        <div className="device-info-popover" role="dialog" aria-label="Device info">
          <div className="device-info-popover-title">Device info</div>
          <dl className="device-info-popover-list">
            {DETAIL_ROWS.map(([label, key]) =>
              details[key] ? (
                <div key={key} className="device-info-popover-row">
                  <dt>{label}</dt>
                  <dd>{details[key]}</dd>
                </div>
              ) : null
            )}
          </dl>
        </div>
      )}
    </div>
  );
};

export default DeviceInfoCell;
